export const useGetParams = () => {
  const searchParams = new URL(document.location).searchParams;
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    demo: searchParams.get('demo') || false,
    user: searchParams.get('user') || '',

    title: getDefaultValue(searchParams.get('title'), 'Присылайте ваш вариант'),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),

    titleFontSize: searchParams.get('titleFontSize') || '7.3',
    sizeQR: searchParams.get('sizeQR') || '65',

    minFontWords: searchParams.get('minFontWords') || 40,
    maxFontWords: searchParams.get('maxFontWords') || 160,
    requestInterval: Number(searchParams.get('requestInterval') || 2000),
  };
};
